import { useState, useEffect, useRef } from 'react';
import { LiveInsightMessage } from '../types/live-insights';
import type { ConnectionState } from '../context/LiveInsightsContextShared';

export function useLiveInsightsWebSocket(sessionId: string) {
    const [messages, setMessages] = useState<LiveInsightMessage[]>([]);
    const [connectionState, setConnectionState] = useState<ConnectionState>('idle');
    const ws = useRef<WebSocket | null>(null);

    useEffect(() => {
        // Connection is managed externally via the audio WebSocket.
        // This hook only serves as a central state store for messages.
        return () => {
            setMessages([]);
        };
    }, [sessionId]);

    const sendMessage = (transcript: string, speakerId: string) => {
        if (ws.current?.readyState === WebSocket.OPEN) {
            ws.current.send(JSON.stringify({ transcript, speaker_id: speakerId }));
        }
    };

    const addMessage = (message: LiveInsightMessage) => {
        setMessages((prev) => [...prev, message]);
    };

    return { connectionState, setConnectionState, messages, sendMessage, addMessage };
}
